module.exports = __webpack_public_path__ + "static/lightning-slider-error-b96f4a5ac0e59c7bcd64f28749dce38b.png";